import { render, staticRenderFns } from "./piechart2.vue?vue&type=template&id=2aa7e13a&scoped=true&"
import script from "./piechart2.vue?vue&type=script&lang=js&"
export * from "./piechart2.vue?vue&type=script&lang=js&"
import style0 from "./piechart2.vue?vue&type=style&index=0&id=2aa7e13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa7e13a",
  null
  
)

export default component.exports